var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-parallax",
    { attrs: { src: "/static/images/15.jpg", height: "100%", jumbotron: "" } },
    [
      _c("center", [
        _c(
          "div",
          { staticClass: "card", staticStyle: { "max-width": "700px" } },
          [
            _c(
              "v-card",
              [
                _c(
                  "v-card-title",
                  { attrs: { "primary-title": "", "mx-auto": "" } },
                  [
                    _c("div", [
                      _c("h3", { staticClass: "headline mb-0" }, [
                        _vm._v(
                          "We’ll just need you to answer a few quick questions. PLEASE NOTE: ARTISTS WILL SEE THESE ACCOUNT DETAILS SO ANSWER WITH CARE"
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "publication",
                        label: "Name of Publication",
                        id: "publication"
                      },
                      model: {
                        value: _vm.publication,
                        callback: function($$v) {
                          _vm.publication = $$v
                        },
                        expression: "publication"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        type: "number",
                        name: "follower_count",
                        label: "Follower Count",
                        id: "follower_count",
                        value: "number"
                      },
                      model: {
                        value: _vm.follower_count,
                        callback: function($$v) {
                          _vm.follower_count = $$v
                        },
                        expression: "follower_count"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "website",
                        id: "website",
                        label: "Website"
                      },
                      model: {
                        value: _vm.website,
                        callback: function($$v) {
                          _vm.website = $$v
                        },
                        expression: "website"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        "multi-line": "",
                        name: "about",
                        id: "about",
                        label: "About – Write a short summary of your page ",
                        rules: [
                          function(v) {
                            return v.length <= 620 || "Max 620 characters"
                          }
                        ],
                        counter: 120,
                        required: ""
                      },
                      model: {
                        value: _vm.about,
                        callback: function($$v) {
                          _vm.about = $$v
                        },
                        expression: "about"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        "multi-line": "",
                        name: "the_good",
                        id: "the_good",
                        label:
                          "Favorite Pieces – what type of posts do you typically share. i.e. paintings, psychedelic, realistic, photography, etc",
                        rules: [
                          function(v) {
                            return v.length <= 620 || "Max 620 characters"
                          }
                        ],
                        counter: 620,
                        required: ""
                      },
                      model: {
                        value: _vm.the_good,
                        callback: function($$v) {
                          _vm.the_good = $$v
                        },
                        expression: "the_good"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-layout", { attrs: { row: "" } }),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        "multi-line": "",
                        name: "additional_notes",
                        id: "additional_notes",
                        label:
                          "Additional Notes – Give an encouraging message that gets artists excited to submit their art to you ",
                        rules: [
                          function(v) {
                            return v.length <= 620 || "Max 620 characters"
                          }
                        ],
                        counter: 620
                      },
                      model: {
                        value: _vm.additional_notes,
                        callback: function($$v) {
                          _vm.additional_notes = $$v
                        },
                        expression: "additional_notes"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    name: "Instagram",
                    label:
                      "Copy and paste your Instagram page URL (https://www.instagram.com/...)",
                    id: "instagram"
                  },
                  model: {
                    value: _vm.instagram,
                    callback: function($$v) {
                      _vm.instagram = $$v
                    },
                    expression: "instagram"
                  }
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    name: "Facebook",
                    label:
                      "Copy and paste your Facebook page URL (https://www.facebook.com/...)",
                    id: "facebook"
                  },
                  model: {
                    value: _vm.facebook,
                    callback: function($$v) {
                      _vm.facebook = $$v
                    },
                    expression: "facebook"
                  }
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    name: "Tumnlr",
                    label:
                      "Copy and paste your Tumblr page URL (https://www.tumblr.com/...)",
                    id: "tumblr"
                  },
                  model: {
                    value: _vm.tumblr,
                    callback: function($$v) {
                      _vm.tumblr = $$v
                    },
                    expression: "tumblr"
                  }
                }),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-layout", { attrs: { row: "" } }, [
                          _c("input", {
                            ref: "fileInput",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", accept: "image/*" },
                            on: { change: _vm.onFilePicked }
                          })
                        ]),
                        _vm._v(" "),
                        _vm.uploaded_image
                          ? _c("img", {
                              attrs: {
                                src: _vm.image_url,
                                width: "50%",
                                height: "auto"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { depressed: "", color: "primary" },
                            on: { click: _vm.onPickFile }
                          },
                          [_vm._v("Upload Your Logo")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { depressed: "", color: "primary" },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("Submit")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "790" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Almost There")
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "Please check your email and verify. If you do not receive email verification within five minutes, please check your junk mail folder."
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        flat: "flat",
                        router: "",
                        to: "/"
                      },
                      on: { click: _vm.onSignOut }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-549ef62a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-549ef62a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/business_signup2.vue
// module id = null
// module chunks = 